import classNames from "classnames";
import { Button, Flex } from "@simplybusiness/mobius";
import { type PaymentTermsOption } from "../../PaymentTermsChecklist";
import { CombinedPaymentButton } from "./CombinedPaymentButton";
import { CancelAnytime } from "../../../CancelAnytime";
export const CallToAction = ({
  enableCheckoutFormSubmission,
  isFormSubmitting,
  fireCheckoutButtonClickedEvent,
  onCallToActionClick,
  buttonText,
  poweredByStripeLogo,
  agreementOptions,
  checkedAgreements,
  setHasAttemptedSubmit,
  eventTrackerCallback,
  combinedPaymentPage,
  legalAgreementButtonsNotCheckedCallback,
  firePayButtonClickedEvent,
}: CallToActionProps) => {
  const allAccepted = agreementOptions.every(opt =>
    checkedAgreements.includes(opt.value),
  );

  const handleCheckoutClick = (e: React.MouseEvent) => {
    setHasAttemptedSubmit(true);
    if (!allAccepted) {
      e.preventDefault();
      if (legalAgreementButtonsNotCheckedCallback) {
        legalAgreementButtonsNotCheckedCallback();
      }
      return;
    }
    fireCheckoutButtonClickedEvent();
  };

  const handlePayClick = () => {
    setHasAttemptedSubmit(true);
    if (!allAccepted) {
      if (legalAgreementButtonsNotCheckedCallback) {
        legalAgreementButtonsNotCheckedCallback();
      }
      return;
    }
    if (firePayButtonClickedEvent) {
      firePayButtonClickedEvent();
    }
    onCallToActionClick(true);
  };

  return (
    <div
      className={classNames("mobius-payment-summary__form-actions-box", {
        "combined-payment-page-sticky": !enableCheckoutFormSubmission,
      })}
    >
      <Flex
        data-testid="payment-cta-container"
        className="mobius-payment-cta-container-align-left mobius-payment-cta-container-align-center"
      >
        {combinedPaymentPage && (
          <CancelAnytime eventTrackerCallback={eventTrackerCallback} />
        )}
        {enableCheckoutFormSubmission ? (
          <Button
            className="mobius-payment-summary__checkout-button"
            type="submit"
            size="md"
            isLoading={isFormSubmitting}
            isDisabled={isFormSubmitting}
            data-testid="submit-btn"
            onClick={handleCheckoutClick}
          >
            Checkout
          </Button>
        ) : (
          <CombinedPaymentButton
            buttonText={buttonText}
            poweredByStripeLogo={poweredByStripeLogo}
            onClick={handlePayClick}
          />
        )}
      </Flex>
    </div>
  );
};

export interface CallToActionProps {
  enableCheckoutFormSubmission: boolean;
  isFormSubmitting: boolean;
  fireCheckoutButtonClickedEvent: () => void;
  onCallToActionClick: (drawerOpen: boolean) => void;
  buttonText: string;
  poweredByStripeLogo: string;
  agreementOptions: PaymentTermsOption[];
  eventTrackerCallback: () => void;
  legalAgreementButtonsNotCheckedCallback?: () => void;
  firePayButtonClickedEvent?: () => void;
  checkedAgreements: string[];
  setHasAttemptedSubmit: (value: boolean) => void;
  combinedPaymentPage: boolean;
}
